<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Move Character to User</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12"
                   lg="4"
                   xl="3"
                   v-for="(user, userIndex) of users"
                   :key="userIndex">

                <v-card>
                    <v-card-title>
                        {{ user.name }}
                    </v-card-title>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="setUser(user)"
                                       v-on="on"
                                >
                                    <v-icon>mdi-lock-open</v-icon>
                                </v-btn>
                            </template>
                            <span>Unlock Class</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import UserService from "../services/UserService";
  import CharacterService from "../services/CharacterService";

  export default {
    data: () => ({
      users: []
    }),

    created() {
      this.indexUsers();
    },

    methods: {
      indexUsers() {
        UserService.availableToCharacter(this.$route.params.characterId)
          .then(response => {
            this.users = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      setUser(user) {
        if (confirm(`Are you sure you want to move the character to the user ${user.name}?`)) {
          CharacterService.updateUser(this.$route.params.characterId, user.id)
            .then(() => {
              this.$router.push({name: 'characters'});
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  };
</script>
